import { makeAction, makeReducer } from '@finn-no/redux-actions';

import { mapBestOffers, supremeOffer } from '../bestOffers/bestOffers.js';
import lowfareActions from './lowfareActions.js';
import { pagination } from '../pagination/pagination.js';
import poll from '../polling/poll.js';
import { gtmActions } from './gtm.js';

const actions = {};

actions.setResultData = makeAction('SET_RESULT_DATA', (state, { payload }) => ({
    ...state,
    skeleton: false,
    searchId: payload.searchId,
    request: payload.request ? payload.request : state.request,
    showProgressIndicator: payload.showProgressIndicator !== false,
    progress: payload.progress >= state.progress ? payload.progress : state.progress,
    stats: payload.stats ? payload.stats : state.stats,
    lowfare: payload.lowFares ? payload.lowFares : state.lowfare,
    trips: payload.trips,
    numberOfResults: payload.groupCount ? +payload.groupCount : 0,
    bestOffers: mapBestOffers(payload.bestOffers, state.filterState.sortCriteria),
    supremeOffer: supremeOffer(payload.bestOffers),
    pagination: pagination(payload.totalPages, payload.currentPage),
    filterData: {
        ...state.filterData,
        airlines: payload.airlines,
        departureAirportLeg1: payload.departureAirportLeg1,
        arrivalAirportLeg1: payload.arrivalAirportLeg1,
        departureAirportLeg2: payload.departureAirportLeg2,
        arrivalAirportLeg2: payload.arrivalAirportLeg2,
        stopoverAirports: payload.stopoverAirports,
        cabinType: payload.cabinType,
        maximumNumberOfStops: payload.maximumNumberOfStops,
        price: payload.stats ? payload.stats.price : state.filterData.price,
        duration: payload.stats ? payload.stats.duration : state.filterData.duration,
        outboundDepartureTime: payload.stats ? payload.stats.outboundDepartureTime : state.filterData.outboundDepartureTime,
        outboundArrivalTime: payload.stats ? payload.stats.outboundArrivalTime : state.filterData.outboundArrivalTime,
        inboundDepartureTime: payload.stats ? payload.stats.inboundDepartureTime : state.filterData.inboundDepartureTime,
        inboundArrivalTime: payload.stats ? payload.stats.inboundArrivalTime : state.filterData.inboundArrivalTime,
    },
    showFilters: !!((payload.trips && payload.trips.length) || (payload.stats && payload.stats.price)),
}));

actions.startPoll = payload => (dispatch, getState) => {
    dispatch(actions.setStartPoll());
    dispatch(lowfareActions.setSearching(true));

    poll(payload, getState, dispatch);
};

actions.setStartPoll = makeAction('EVENT/START_POLL', state => ({
    ...state,
    showFilters: false,
    pollingComplete: false,
    showProgressIndicator: true,
    progress: 0,
    progressClass: '',
    numberOfResults: 0,
    trips: [],
    bestOffers: null,
    supremeOffer: null,
    pagination: { ...state.pagination, showPagination: false },
}));

actions.pollingComplete = () => dispatch => {
    dispatch(actions.setPollingComplete());
    setTimeout(() => dispatch(actions.setProgressClass('hiddenByOpacity')), 500);
    setTimeout(() => dispatch(actions.setShowProgressIndicator(false)), 1000);
};

actions.setShowProgressIndicator = makeAction('SET_SHOW_PROGRESS_INDICATOR', (state, { payload }) => ({
    ...state,
    showProgressIndicator: payload,
    progressClass: payload ? state.progressClass : '',
}));

actions.setPollingComplete = makeAction('EVENT/POLLING_COMPLETE', state => ({
    ...state,
    loading: false,
    progress: 100,
    pollingComplete: true,
    showExpiredResultsMessage: false,
}));

actions.requestReceived = payload => dispatch => {
    dispatch(actions.showExpiredResultsMessage(document.location.hash === '#resultExpired'));
    dispatch(actions.showBanners(true));
    dispatch(gtmActions.resultPageLoaded(payload));
};

actions.setLoading = makeAction('SET_LOADING', 'loading');

actions.setProgressClass = makeAction('SET_PROGRESS_CLASS', 'progressClass');

actions.setMobileFilterOverlay = makeAction('SET_MOBILE_FILTER_OVERLAY', 'showMobileFilterOverlay');

actions.showExpiredResultsMessage = makeAction('SHOW_EXPIRED_MESSAGE', 'showExpiredResultsMessage');

actions.toggleSearchForm = makeAction('TOGGLE_SEARCH_FORM', state => ({
    ...state,
    showSearchDetails: !state.showSearchDetails,
    showSearchForm: !state.showSearchForm,
}));

actions.showBoards = makeAction('ADS/SHOW_BOARDS', state => {
    if (state.pollingComplete) {
        FINN.banner.appNexus.showBoards(document.querySelectorAll('[data-resultlist-banner]'));
    }
});

actions.showBanners = makeAction('ADS/SHOW_BANNERS', (state, { payload }) => {
    if (state.pollingComplete || payload) {
        const city = state.request.requestedDestinationCity || state.searchForm.destinationCity;
        const country = state.request.requestedDestinationCountry || state.searchForm.destinationCountry;

        FINN.banner.appNexus.showBanners(document.querySelectorAll('[data-horseshoe-banner]'), {
            city: city ? city.toLowerCase() : '',
            country: country ? country.toLowerCase() : '',
        });
    }
});

actions.initSearchPage = () => dispatch => {
    dispatch(actions.showBanners(true));
    // TODO do async with setTimeout()?
    dispatch(gtmActions.searchPageLoaded());
};

// The default export contains all actions
export default actions;

// The exported reducer handles actions created with plain action creators
export const reducer = makeReducer(actions);
